<!-- eslint-disable -->
<template lang="pug">
    .game-content
        //div(
        //    :class="{\
        //        'is-1-desktop': !showTurtle,\
        //        'column': !showTurtle\
        //    }"
        //)
        // GAMES_WRAPPER
        //:class="{\
        //    'multi-screen': playersNumber > 1,\
        //    'four-screen': playersNumber === 4,\
        //    'is-10-desktop': playersNumber === 1 || !playersNumber\
        //}",
        games-wrapper(
            :type='type',
            :exercise-id='exerciseId',
            :homework-id='homeworkId',
            :players-number='playersNumber',
            :play-again='playAgain',
            @playAgainReady='$event ? playAgainReadyScreens++ : playAgainReadyScreens--',
            @checkAnswersReady='$event ? checkAnswersReadyScreens++ : checkAnswersReadyScreens--'
        )
        //multi-screen-buttons.column.is-12.is-12-mobile(
        //    v-if='playersNumber > 1',
        //    :type='type',
        //    @playagain='sendPlayAgainEvent',
        //    :checkanswersreadyscreens='checkAnswersReadyScreens',
        //    :playagainreadyscreens='playAgainReadyScreens'
        //)

</template>

<script>
    /*eslint-disable*/
    import PlayBox from './PlayBox.vue';
    import MultiScreenButtons from '../../MultiScreenButtons.vue';
    import GamesWrapper from '../GamesWrapper.vue'
    import {mapState} from 'vuex'

    export default {
        data () {
            return {
                showTurtle: true,
                playAgain: false,
                playAgainReadyScreens: 0,
                checkAnswersReadyScreens: 0
            };
        } ,
        props: ['exerciseId', 'homeworkId', 'type'],
        methods: {
            sendPlayAgainEvent () {
                this.playAgain = true;
                this.$nextTick(() => {
                    this.playAgain = false;
                });
            }
        },
        computed: {
            ...mapState({
                paramsArray: state => state.trainer.paramsArray
            }),
            playersNumber () {
                return this.paramsArray ? this.paramsArray.length : 1;
            }
        },
        components: {
            PlayBox,
            MultiScreenButtons,
            GamesWrapper
        },
        beforeRouteLeave (to, from, next) {
            if (this.$store.state.trainer.game) {
                if (!(to.meta.type && to.meta.type === 'trainer')) {
                    this.$store.dispatch('setHomework', null);
                    this.$store.dispatch('setGame', null);
                }
            }
            next();
        }
    }
</script>

<style lang="scss" scoped>
    @import "@/assets/sass/games/main.scss";
</style>
